"use client";

import { useDrawer } from "../../context/DrawerContext";
import Navbar from "../navigation/navbar";
import Footer from "../sections/footer";
import ScrollToTop from "../ui/scroll-to-top";
import { Toaster } from "react-hot-toast";

interface LayoutContentProps {
  children: React.ReactNode;
}

export default function LayoutContent({ children }: LayoutContentProps) {
  const { isDrawerOpen } = useDrawer();

  return (
    <>
      <Navbar />
      <main className="bg-white min-w-full">{children}</main>
      <Footer />
      <ScrollToTop isDrawerOpen={isDrawerOpen} />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: "#363636",
            color: "#fff",
          },
          success: {
            duration: 3000,
            style: {
              background: "#263A8D",
              color: "#fff",
            },
          },
          error: {
            duration: 4000,
            style: {
              background: "#EF4444",
              color: "#fff",
            },
          },
        }}
      />
    </>
  );
}
